<template>
    <v-dialog
        scrollable
        v-model="dialog"
        fullscreen
        persistent
        @keydown.esc="dialog = false"
    >
        <v-card v-if="loading">
            <v-card-text class="pt-5">
                <v-col class="text-center" xs="12" md="12">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>

                <v-col class="text-center">
                    {{ $t('modules.selection.loading') }}
                </v-col>
            </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-title primary-title class="title grey lighten-4">
                <v-icon left>mdi-file-document-box-check</v-icon>
                {{
                    $t('modules.selection.title', {
                        prefix: $t('form.actions.select'),
                    }) +
                        ': ' +
                        customer.trade_name
                }}
                <v-spacer />
                <v-btn
                    fab
                    x-small
                    elevation="3"
                    @click="dialog = false"
                    outlined
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-stepper v-model="step" elevation="0">
                    <v-stepper-header class="pt-2">
                        <v-stepper-step :complete="step > 1" step="1">
                            {{ $t('dialogs.customer.changePlan.step1') }}
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="step > 2" step="2">
                            {{ $t('dialogs.customer.changePlan.step2') }}
                        </v-stepper-step>

                        <v-divider></v-divider>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <!-- PLANS SLIDE -->
                            <v-slide-group
                                v-model="slide"
                                center-active
                                show-arrows
                                @change="selectPlan"
                            >
                                <template #next>
                                    <v-btn
                                        elevation="5"
                                        fab
                                        style="margin-top: -20rem;"
                                        small
                                    >
                                        <v-icon>
                                            mdi-chevron-right
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <template #prev>
                                    <v-btn
                                        elevation="5"
                                        fab
                                        style="margin-top: -20rem;"
                                        small
                                    >
                                        <v-icon>
                                            mdi-chevron-left
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-spacer />
                                <v-slide-item
                                    v-for="planPackage in planPackages"
                                    :key="`planPackage_${planPackage.id}`"
                                    v-slot="{ active, toggle }"
                                >
                                    <v-card
                                        :class="[
                                            'text-center',
                                            'd-flex flex-column',
                                            'justify-space-between',
                                            active
                                                ? slideActive
                                                : 'mx-2 py-4 px-3',
                                        ]"
                                        :elevation="active ? 5 : 2"
                                    >
                                        <div class="d-flex justify-center">
                                            <v-btn
                                                v-if="
                                                    planPackage.id !==
                                                        selectedPlanPackageId
                                                "
                                                small
                                                outlined
                                                @click="
                                                    selectPlanPackage(
                                                        planPackage,
                                                    )
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'modules.selection.select-this-plan',
                                                    )
                                                }}
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                x-small
                                                fab
                                                elevation="0"
                                                color="success"
                                            >
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-divider
                                            class="mt-4 mb-2"
                                        ></v-divider>
                                        <PlanInfo :planPackage="planPackage" />
                                        <v-divider class="mt-2"></v-divider>
                                        <div class="flex-grow-1">
                                            <div
                                                class="mt-4"
                                                v-if="
                                                    planPackage.modules.filter(
                                                        m => !m.add_on,
                                                    ).length
                                                "
                                            >
                                                <h3
                                                    class="text-center t-heading-small grey--text pb-2"
                                                >
                                                    {{
                                                        $t(
                                                            'resources.planProposal.attributes.fixed_modules',
                                                        )
                                                    }}
                                                </h3>
                                                <div
                                                    v-for="module in planPackage.modules.filter(
                                                        m => !m.add_on,
                                                    )"
                                                    :key="module.id"
                                                    class="pl-1 pt-0 d-flex align-center justify-center"
                                                >
                                                    <div
                                                        class="d-flex align-center justify-center"
                                                    >
                                                        <h4
                                                            v-if="
                                                                module.amount >
                                                                    0
                                                            "
                                                        >
                                                            {{ module.amount }}x
                                                        </h4>
                                                        &nbsp;
                                                        <h4>
                                                            {{
                                                                module.module
                                                                    .name
                                                            }}
                                                        </h4>
                                                        <div
                                                            class="text-caption text-muted"
                                                            v-if="
                                                                module.price_type ===
                                                                    'per_unit'
                                                            "
                                                        >
                                                            <span>
                                                                &nbsp;({{
                                                                    $n(
                                                                        module
                                                                            .module
                                                                            .price,
                                                                        'currency',
                                                                    )
                                                                }}
                                                                por unidade)
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="mt-4"
                                                v-if="
                                                    planPackage.modules.filter(
                                                        m => m.add_on,
                                                    ).length
                                                "
                                            >
                                                <v-btn
                                                    text
                                                    small
                                                    block
                                                    class="t-heading-small grey--text"
                                                    @click="
                                                        toggleOptionalModules(
                                                            planPackage.id,
                                                        )
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            'resources.planProposal.attributes.optional_modules',
                                                        )
                                                    }}
                                                    <v-icon right small>
                                                        {{
                                                            isOptionalModulesExpanded(
                                                                planPackage.id,
                                                            )
                                                                ? 'mdi-chevron-up'
                                                                : 'mdi-chevron-down'
                                                        }}
                                                    </v-icon>
                                                </v-btn>
                                                <v-expand-transition>
                                                    <div
                                                        v-show="
                                                            isOptionalModulesExpanded(
                                                                planPackage.id,
                                                            )
                                                        "
                                                        class="pt-2"
                                                    >
                                                        <div
                                                            v-for="module in planPackage.modules.filter(
                                                                m => m.add_on,
                                                            )"
                                                            :key="module.id"
                                                            class="pl-1 pt-0 d-flex align-center justify-center"
                                                        >
                                                            <div
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <h4>
                                                                    {{
                                                                        module
                                                                            .module
                                                                            .name
                                                                    }}
                                                                </h4>
                                                                &nbsp;<span
                                                                    class="text-caption text-muted"
                                                                    >{{
                                                                        module.priceBr
                                                                    }}</span
                                                                >
                                                            </div>
                                                            <div
                                                                class="text-caption text-muted"
                                                            >
                                                                <template
                                                                    v-if="
                                                                        module.max_amount >
                                                                            module.amount
                                                                    "
                                                                >
                                                                    &nbsp;
                                                                    Disponível:
                                                                    {{
                                                                        module.max_amount -
                                                                            module.amount
                                                                    }}
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-expand-transition>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-slide-item>
                                <v-spacer />
                            </v-slide-group>
                            <!-- /PLANS SLIDE -->
                        </v-stepper-content>
                        <v-stepper-content step="2" class="justify-center">
                            <v-spacer />
                            <v-row v-if="planPackage">
                                <v-col cols="7">
                                    <module-selector
                                        ref="moduleSelector"
                                        :modules="optionalModules"
                                        :plan-package-id="
                                            planProposal.planPackage.id
                                        "
                                        :active-module-ids="activeModuleIds"
                                        :fixed-modules="fixedModules"
                                        @checked="checked"
                                        @addAmount="addAmount"
                                    />
                                </v-col>

                                <v-col cols="5">
                                    <plan-proposal-summary
                                        :key="summaryKey"
                                        :plan-package="planProposal.planPackage"
                                        :total-price="planProposal.total_price"
                                        :final-price="planProposal.final_price"
                                        :discount="
                                            planProposal.proposal.discount
                                        "
                                        :fixed-modules="fixedModules"
                                        :add-on-selected="addOnSelected"
                                    />
                                </v-col>
                            </v-row>
                            <v-spacer />
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-footer class="pa-5 d-flex justify-space-around">
                <!-- PLANO SELECIONADO -->
                <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="2">
                    <div class="subtitle-2 font-weight-medium">
                        {{ $t('modules.selection.plan-selected') }}
                    </div>
                    <div class="pt-1 pb-2">
                        <template v-if="planPackage">
                            {{ planPackage.name }}
                        </template>
                        <span v-else class="body-2 font-weight-light">
                            {{ $t('modules.selection.plan-not-selected') }}
                        </span>
                    </div>
                </v-col>
                <!-- /PLANO SELECIONADO -->

                <!-- CUSTOMER DISCOUNT -->
                <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    v-if="customer.discount"
                >
                    <div>
                        <div class="subtitle-2 font-weight-medium">
                            Desconto do Cliente
                        </div>
                        <div class="pt-1 pb-2">
                            {{ $n(customer.discount, 'currency') }}
                        </div>
                    </div>
                </v-col>
                <!-- /CUSTOMER DISCOUNT -->

                <!-- CATEGORY DISCOUNT -->
                <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    v-if="category.discount_percentage"
                >
                    <div>
                        <div class="subtitle-2 font-weight-medium">
                            Desconto Categoria
                        </div>
                        <div class="pt-1 pb-2">
                            {{
                                $n(
                                    category.discount_percentage / 100,
                                    'percent',
                                )
                            }}
                        </div>
                    </div>
                </v-col>
                <!-- /CATEGORY DISCOUNT -->

                <!-- VALOR A PAGAR PARA CPLUG -->
                <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="2">
                    <div>
                        <div class="subtitle-2 font-weight-medium">
                            {{ $t('modules.selection.price') }}
                        </div>

                        <div
                            class="pt-1 pb-2"
                            v-bind:class="{ 'red--text': hasDiscounts }"
                        >
                            {{
                                $n(
                                    planProposal ? finalPriceCalculated : 0,
                                    'currency',
                                )
                            }}
                        </div>
                    </div>
                </v-col>
                <!-- /VALOR A PAGAR APRA CPLUG -->

                <!-- PREÇO PARA O CLIENTE -->
                <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    v-if="step == 2"
                >
                    <div>
                        <div class="subtitle-2 font-weight-medium">
                            {{ $t('modules.selection.over-price') }}
                        </div>
                        <v-currency-field
                            v-if="planPackage"
                            v-bind="$t('money-config')"
                            v-model="userOverValue"
                            dense
                            :hide-details="false"
                            :hint="
                                minOverValue > 0
                                    ? `Valor mínimo: ${$n(
                                          minOverValue,
                                          'currency',
                                      )}`
                                    : ''
                            "
                            persistent-hint
                        ></v-currency-field>
                    </div>
                </v-col>

                <!-- /PREÇO PARA O CLIENTE -->
                <v-btn @click="previousStep()" v-if="step == 2">
                    {{ $t('dialogs.customer.changePlan.prevStep') }}
                </v-btn>

                <v-btn
                    color="primary"
                    @click="nextStep"
                    v-if="step == 1"
                    :disabled="!this.planPackage"
                >
                    {{ $t('dialogs.customer.changePlan.nextStep') }}
                </v-btn>
                <v-btn
                    v-if="step == 2"
                    elevation="2"
                    color="success"
                    :loading="loading"
                    @click="save"
                    :disabled="userOverValue < minOverValue"
                >
                    <v-icon light>mdi-check</v-icon>
                    {{ $t('dialogs.customer.changePlan.save') }}
                </v-btn>
            </v-footer>
        </v-card>

        <Confirm
            ref="confirm"
            confirmColor="green darken-1"
            :cancelText="$t('actions.customer.planSelection.backButton')"
        />
    </v-dialog>
</template>

<script>
import Category from '@/models/Category'
import Confirm from '@/shared/components/Confirm'
import PlanInfo from '@/components/plans/PlanInfo'
import { usePlanProposalManager } from '@/shared/services/usePlanProposalManager'

import {
    buildModulesPayload,
    formatPlanPackages,
} from '@/shared/services/planModulesService'

const PlanProposalSummary = () =>
    import('@/shared/components/planProposal/PlanProposalSummary.vue')
const ModuleSelector = () =>
    import('@/shared/components/planProposal/ModuleSelector.vue')

const getInitialState = () => ({
    dialog: false,
    loading: true,
    customer: null,
    customerPlan: null,
    step: 1,
    slide: null,
    planPackages: [],
    planPackage: null,
    userOverValue: 0,
    category: null,
    discountCode: null,
    activeModuleIds: [],
    expandedOptionals: [],
})

export default {
    components: {
        Confirm,
        PlanInfo,
        ModuleSelector,
        PlanProposalSummary,
    },

    data: () => ({
        ...getInitialState(),
        manager: null,
    }),

    created() {
        this.initManager()
    },

    watch: {
        dialog(value) {
            if (value === false) {
                this.resetState()
            }
        },

        // Watch automático para ajustar userOverValue quando minOverValue mudar
        minOverValue(newValue, oldValue) {
            if (newValue !== oldValue) {
                const delta = newValue - oldValue
                this.userOverValue = Math.max(
                    newValue,
                    this.userOverValue + delta,
                )
            }
        },
    },

    computed: {
        hasDiscounts() {
            const categoryDiscount =
                this.category && this.category.discount_percentage
            const customerDiscount = this.customer && this.customer.discount
            return !!(categoryDiscount || customerDiscount)
        },

        slideActive() {
            return 'mx-3 py-5 px-5'
        },

        selectedPlanPackageId() {
            return this.planPackage && this.planPackage.id
                ? this.planPackage.id
                : null
        },

        planProposal() {
            return this.manager && this.manager.planProposal
                ? this.manager.planProposal
                : { proposal: { modules: [] } }
        },

        fixedModules() {
            return this.manager && this.manager.fixedModules
                ? this.manager.fixedModules
                : []
        },

        optionalModules() {
            return this.manager && this.manager.optionalModules
                ? this.manager.optionalModules
                : []
        },

        addOnSelected() {
            return this.manager && this.manager.addOnSelected
                ? this.manager.addOnSelected
                : []
        },

        comboItems() {
            return this.manager && this.manager.comboItems
                ? this.manager.comboItems
                : []
        },

        summaryKey() {
            return this.manager && this.manager.summaryKey
                ? this.manager.summaryKey
                : 'summary-empty'
        },

        // Calcula o valor mínimo baseado nos apps de parceiros
        minOverValue() {
            if (
                !this.planProposal.proposal ||
                !this.planProposal.proposal.modules
            )
                return 0

            return this.planProposal.proposal.modules
                .filter(module => {
                    const isThirdParty =
                        module.third_party ||
                        (module.module && module.module.third_party)
                    if (!isThirdParty) return false
                    return module.amount > 0 || module.add_amount > 0
                })
                .reduce((sum, module) => {
                    const price = module.price || 0
                    const amount = module.add_amount || module.amount || 0
                    return sum + price * amount
                }, 0)
        },

        finalPriceCalculated() {
            let finalPrice = 0

            if (this.planProposal) {
                finalPrice =
                    this.category && this.category.discount_percentage
                        ? this.planProposal.final_price -
                          this.planProposal.final_price *
                              (this.category.discount_percentage / 100)
                        : this.planProposal.final_price

                finalPrice =
                    this.customer && this.customer.discount
                        ? finalPrice - this.customer.discount
                        : finalPrice
            }

            return finalPrice > 0 ? finalPrice : 0
        },
    },

    methods: {
        resetState() {
            Object.assign(this.$data, getInitialState())
            this.initManager()
        },

        initManager() {
            this.manager = usePlanProposalManager({
                vue: this,
                discountCode: { value: this.discountCode },
            })
        },

        toggleOptionalModules(planPackageId) {
            let index = this.expandedOptionals.indexOf(planPackageId)

            if (index === -1) {
                this.expandedOptionals.push(planPackageId)
                return
            }

            this.expandedOptionals.splice(index, 1)
        },

        isOptionalModulesExpanded(planPackageId) {
            return this.expandedOptionals.indexOf(planPackageId) !== -1
        },

        checked(module) {
            this.manager.checked(module)
        },

        addAmount(module) {
            this.manager.addAmount(module)
        },

        selectPlanPackage(planPackage, options = {}) {
            const {
                skipOptionalReset = false,
                customerPlan = null,
            } = options

            if (!skipOptionalReset) {
                this.resetOptionalModules()
            }
            this.planPackage = planPackage

            this.manager.selectPlanPackage(this.planPackage, {
                keepModules: false,
                customerPlan,
            })
        },

        resetOptionalModules() {
            this.planPackages.forEach(planPackage => {
                if (planPackage.modules) {
                    planPackage.modules.forEach(module => {
                        if (module.add_on) {
                            this.$set(module, 'selected', false)
                            this.$set(module, 'checked', false)
                            this.$set(module, 'add_amount', 0)
                            this.$set(module, 'locked', false)
                            this.$set(module, 'skipActivePrefill', false)
                            this.$set(module, 'amount', 0)
                        }
                    })
                }
            })
        },

        // Chamado quando o slide muda (recebe o índice do plano)
        selectPlan(planIndex) {
            const selectedPlanPackage = this.planPackages[planIndex]
            if (!selectedPlanPackage) return

            if (
                this.planPackage &&
                this.planPackage.id === selectedPlanPackage.id
            ) {
                return
            }

            this.selectPlanPackage(selectedPlanPackage)
        },

        async loadCustomerRelations(customer) {
            this.customer = await customer.find(customer.id)
            if (!this.customer.activePlan) return

            this.customerPlan = this.customer.activePlan

            const planModules = this.customerPlan.planModules || []
            const thirdPartyTotal = planModules
                .filter(module => module.third_party)
                .reduce(
                    (sum, module) =>
                        sum + parseFloat(module.total_price || 0),
                    0,
                )

            this.userOverValue =
                parseFloat(this.customerPlan.over_value || 0) - thirdPartyTotal
        },

        initCustomerPlan() {
            if (!this.customerPlan || !this.planPackages.length) return

            const packageId =
                this.customerPlan.plan_package_id || this.customerPlan.plan_id

            const index = this.planPackages.findIndex(
                planPackage => planPackage.id == packageId,
            )

            if (index < 0) return

            this.slide = index
            this.selectPlanPackage(this.planPackages[index], {
                skipOptionalReset: true,
                customerPlan: this.customerPlan,
            })
        },

        /** DATA HANDLERS */

        async open(customer) {
            this.loading = true
            this.dialog = true
            this.initManager()
            this.customer = customer

            try {
                await Promise.all([
                    this.loadPlans(customer.id),
                    this.loadCategory(customer),
                    this.loadCustomerRelations(customer),
                ])
                this.initCustomerPlan()
            } finally {
                this.loading = false
            }
        },

        detectAndMarkAdditionals(modules) {
            const seen = {}
            return modules.map(module => {
                const key = module.id

                if (seen[key]) {
                    module.add_on = true  // 2ª ocorrência = adicional
                } else {
                    module.add_on = false  // 1ª ocorrência = fixo
                    seen[key] = true
                }
                return module
            })
        },

        async loadPlans(customerId) {
            const res = await this.$http.get(`config-plans/${customerId}`)
            if (!res) {
                this.dialog = false
                return
            }
            this.planPackages = formatPlanPackages(res.data.planPackages)
            this.activeModuleIds = this.detectAndMarkAdditionals(
                res.data.activeModuleIds || []
            )
        },

        async loadCategory(customer) {
            if (customer.category) {
                this.category = customer.category
                return
            }

            const category = await new Category().currentCategory()
            this.category = category || {}
        },

        nextStep() {
            this.step++
        },

        previousStep() {
            this.step--
        },

        async save() {
            const confirm = await this.$refs.confirm.open(
                this.$t('actions.customer.planSelection.confirmSelectionTitle'),
                this.$t('actions.customer.planSelection.confirmSelectionText'),
            )

            if (!confirm) return

            const modules = buildModulesPayload({
                fixedModules: this.fixedModules,
                optionalAddOnSelected: this.addOnSelected,
            })

            const payload = {
                plan_package_id: this.planPackage.id,
                value: this.planProposal.total_price,
                final_price: this.planProposal.final_price,
                modules,
                over_value: this.userOverValue,
            }

            this.dialog = false
            const res = await this.customer.changePlan(payload)

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.customer.feedbacks.changed_plan'),
            )

            this.$emit('modelChanged')

            this.slide = null
            this.planPackage = null
            this.dialog = false
        },
    },
}
</script>

<style lang="scss">
.v-slide-group__wrapper {
    padding: 5px 0;
}
</style>
